module.exports = __webpack_public_path__ + "img/Download - Pink - Selected.70db83b6.png";